export default __webpack_public_path__ + "static/media/logo.e4bb51b2.png";